import React, { createContext, useContext, useEffect, useState } from 'react'

const AuthContext = createContext({
  isAuthenticated: false,
  token: null,
  login: () => {},
  logout: () => {},
})

export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedToken = localStorage.getItem('token')
      if (savedToken) {
        setToken(savedToken)
        setIsAuthenticated(true)
      }
    }
  }, [])

  const login = (tokenValue) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('token', tokenValue)
      setToken(tokenValue)
      setIsAuthenticated(true)
    }
  }

  const logout = () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('token')
      localStorage.removeItem('user') // Also remove user profile when logging out
      setToken(null)
      setIsAuthenticated(false)
    }
  }

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}
